import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FB_GAS_APP_ID, FACEBOOK_OAUTH_URL } from '../../../constants';
import { trans } from '../../../localization/language';

import * as facebookActions from '../../../actions/facebook'
import FacebookUser from "./FacebookUser";

class InitFacebookConnect extends React.Component{


	renderToConnect(){
		let params = {
			'client_id': FB_GAS_APP_ID,
			'response_type': 'token',
			'scope': "public_profile,email,user_friends",
			'redirect_uri': window.location.href.replace('/init', '/proceed')
		};
		let sParams = '';
		for(let key in params) {
			sParams += '&' + key + '=' + params[key];
		}
		let uri = FACEBOOK_OAUTH_URL + '?' + sParams.substr(1);
		return (
			<div className="content-item--ipage__main">
				<div className="content__sendinfo">
					{trans('facebook_connect_hint')}
				</div>
				<div className="content__form">
					<a href={uri} >
					   <button type="button" className="content__submit">{trans('connect_action')}</button>
					</a>
				</div>
			</div>
		)
	}

	renderConnected(){
		return (
			<div className="content-item--ipage__main">
				<div className="content_sendinfo">
					{trans('facebook_connected')}
				</div>
				<div className="content__form">
					<FacebookUser fb_uid={this.props.fb_account.fb_uid} fb_username={this.props.fb_account.fb_username}/>
				</div>
			</div>
		)
	}

	render() {
		if ((this.props.fb_account === undefined || this.props.fb_account === null) && !this.props.is_fbconnect_enabled) {
			return null;
		}
		let title = trans('connect_facebook_title');
		let content = this.renderToConnect();
		if(this.props.fb_account != null){
			title = trans('facebook_connected_title');
			content = this.renderConnected();
		}
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{title}
					</div>
					<div className="content-item__main">
						{content}
					</div>
				</div>
			</div>
		);
	};
}

function mapStateToProps(state){
	return {
		fb_account: state.data.userInfo.fb_account,
		is_fbconnect_enabled: state.data.userInfo.is_fbconnect_enabled,
	};
}

function mapDispatchToProps(dispatch){
	return bindActionCreators(Object.assign({}, facebookActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(InitFacebookConnect);



// WEBPACK FOOTER //
// ./app/components/security/facebook/InitFacebookConnect.js